export const newBillEndpoint =
  "https://www.tusfacturas.app/app/api/v2/facturacion/nuevo";
export const getClientByCuitEndpoint =
  "https://www.tusfacturas.app/app/api/v2/clientes/afip-info";
export const serviceStatusEndpoint =
  "https://www.tusfacturas.app/app/api/v2/estado_servicios/alertas";
export const resendBillEndpoint =
  "https://www.tusfacturas.app/app/api/v2/facturacion/reenviar";

// Reportes de tusfacturas.app.
// Este endpoint NO devuelve datos: encola el libro IVA y lo manda por mail.
export const ivaBookEndpoint =
  "https://www.tusfacturas.app/app/api/v2/micuenta/iva_compras_ventas";
export const sendEmailEndpoint = process.env.NODE_ENV === 'development' 
    ? "http://localhost/support/api/send-email.php"
    : "/api/send-email.php";

// Consulta de CUIT a ARCA.
//
// La fuente por defecto es tusfacturas.app (getClientDataByCuit en post.js), que
// ya se usa para validar el CUIT al guardar y devuelve la constancia completa en
// `constancia_full_datos`. Sale del navegador: no necesita certificado digital
// ni nada instalado en el servidor.
//
// El backend propio (api/afip-cuit.php, que pega directo a ARCA con certificado)
// queda como respaldo OPCIONAL: solo se usa si se define esta variable. Vacia,
// no se consulta nunca. Ver api/afip/README.md.
const afipBase = (process.env.REACT_APP_AFIP_API_URL || "").replace(/\/+$/, "");

export const afipBackendConfigurado = afipBase !== "";

export const afipCuitEndpoint = (cuit) =>
  `${afipBase}/afip-cuit.php?cuit=${encodeURIComponent(cuit)}`;
export const afipEstadoEndpoint = `${afipBase}/afip-estado.php`;
